import {AbstractMainModalView} from "../../../views/AbstractMainModalView";
import {
  IDeleteEntityController,
  IT_DELETE_ENTITY_CONTROLLER,
  MK_DELETE_ENTITY
} from "../_controllers/IDeleteEntityController";
import {DialogService, DynamicDialogRef} from "primeng/dynamicdialog";
import {DeleteEntityModel} from "../_models/DeleteEntityModel";
import {Component, InjectionToken} from "@angular/core";
import {ModalFooterView} from "../../modal-footer/_views/modal-footer.view";
import {CommonConstants} from "../../../constants/CommonConstants";

@Component({
  selector: 'link-delete-entity',
  templateUrl: './delete-entity.view.html',
  styleUrls: ['./delete-entity.view.scss'],
})
export class DeleteEntityView extends AbstractMainModalView<IDeleteEntityController> {

  protected readonly model: DeleteEntityModel;
  private expandedState = false;

  constructor(dialogService: DialogService,
              dialogRef: DynamicDialogRef) {
    super(dialogService, dialogRef);

    this.model = this.getController().getModel(MK_DELETE_ENTITY);
  }

  protected onExpandCollapseButtonClicked() {
    this.expandedState = !this.expandedState;

    this.getController().handle('ToggleTreeNodes', {expanded: this.expandedState});
  }

  static show(dialogService: DialogService,
              deleteEndpoint: string,
              entityId: number|string,
              entityName: string,
              entityType: string,
              promptDependencyTree: boolean,
              preventDeletionEntityTypes: Array<string> = [],
              preventDeletionMessage: string = '',
              controllerToken: InjectionToken<IDeleteEntityController>|null = null) {
    return dialogService.open(DeleteEntityView, {
      data: {
        __controllerToken: controllerToken || IT_DELETE_ENTITY_CONTROLLER,
        deleteEndpoint: deleteEndpoint,
        entityId: entityId,
        entityName: entityName,
        entityType: entityType,
        promptDependencyTree: promptDependencyTree,
        preventDeletionEntityTypes: preventDeletionEntityTypes,
        preventDeletionMessage: preventDeletionMessage,
      },
      templates: {
        footer: ModalFooterView,
      },
      width: '60vw',
      breakpoints: CommonConstants.modalBreakpoints,
      closable: true,
    });
  }
}
